<template>
    <div>
        <b-card no-body>
            <div class="row">
                <div class="col-2 borda-lateral">
                    <div class="h6 text-titulo">Tipos dos alertas</div>
                    <div class="d-flex mb-1" v-for="tipo in tiposAlertas" :key="tipo.value"><b-form-checkbox @change="desmarcarTodos" v-model="tipo.selecionado"/> <b-badge :style="`background : ${tipo.color}`">{{tipo.text}}</b-badge></div>
                    
                </div>
                <div class="col-10">
                    <div class="d-flex">
                        <b-button class="mr-2" variant="info" @click="selecionarTodos">
                            <i class="fas fa-tasks mr-2"></i>
                            {{marcadoTodos ? 'Desmarcar' : 'Marcar'}} todos
                        </b-button>

                        <b-button v-if="dados.filter(el => el.selecionado).length > 0" variant="danger" @click="excluirAlertas">
                            <i class="fas fa-trash mr-2"></i>
                            Excluir marcados
                        </b-button>
                    </div>
                    <hr>
                    <template v-for="(alerta, index) in dadosFiltrados">
                        <div class="row borda  ml-1 mr-1 p-1" :class="!alerta.visualizado ? 'nao-visualizado' : ''" :key="`alerta_${index}`">
                            <div class="" ><b-form-checkbox @change="resetarMarcarTodos" v-model="alerta.selecionado"/></div>
                            <div class="col-1 mr-3" @dblclick="abrirAlerta(alerta)"><b-badge :style="`background : ${getEnum(alerta.tipo).color}`">{{alerta.tipo}}</b-badge></div>
                            <div class="col-9 ml-3 pointer" @dblclick="abrirAlerta(alerta)">{{alerta.titulo}}</div>
                            <div class="col-12 text-muted pointer corpo" @dblclick="abrirAlerta(alerta)">{{alerta.corpo}}</div>
                        </div>                   
                    </template>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import AlertaService from '@/common/services/alerta/alerta.service';
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { AlertasMixin } from '@/common/mixins/AlertasMixin';
import helpers from '@/common/utils/helpers';
export default {
    mixins : [AlertasMixin],
    data : () => ({
        dados : [],
        marcadoTodos : false,
        excluidos : 0,
        tiposAlertas : []
    }),
    methods : {
        montarTipoAlertas : function(){
            this.tiposAlertas = helpers.TipoAlerta.map(el => {
                el.selecionado = true;
                return el;
            })
        },
        
        getEnum : function(value){
            if(!helpers.getEnum(value))
                return {color : '#333'};
            return helpers.getEnum(value);
        },
        buscarAlertas : function(){
            AlertaService.listar(this.usuario.id).then(response => {
                this.dados = response.data.data.map(alerta => {
                    alerta.corpo = this.pegarCorpo(alerta.mensagem);
                    alerta.titulo = this.pegarTitulo(alerta.mensagem);
                    alerta.selecionado = false;
                    return alerta;
                });
            });
        },
        pegarCorpo : function(mensagem){
            var html = document.createElement('div');
            html.innerHTML = mensagem;
            let corpo = html.getElementsByClassName('corpo')[0].innerHTML;    
            
            return corpo.replace(/<\/?[^>]+(>|$)/g, "");
        },
        pegarTitulo : function(mensagem){
            var html = document.createElement('div');
            html.innerHTML = mensagem;
            let titulo = html.getElementsByClassName('titulo-vue');    

            if(titulo.length == 0){
                return "";
            }
            
            return titulo[0].innerHTML.replace(/<\/?[^>]+(>|$)/g, "");
        },

        abrirAlerta : function(alerta){
            this.$router.push(`/alertas/${alerta.id}`);
        },
        selecionarTodos : function(){
            this.marcadoTodos = !this.marcadoTodos;
            this.dadosFiltrados.forEach(alerta => {
                alerta.selecionado = this.marcadoTodos;
            });
        },
        resetarMarcarTodos : function(){
            this.marcadoTodos = false;
        },

        desmarcarTodos : function(){
            this.marcadoTodos = false;
            this.dados.forEach(alerta => {
                alerta.selecionado = this.marcadoTodos;
            });
        },

        excluirAlertas : function(){
            this.confirmar("Deseja excluir os alertas selecionados?").then(confirmado => {
                if(!confirmado){
                    return;
                }

                let alertas = this.dados.filter(alerta => alerta.selecionado).map(el => el.id);
                
                AlertaService.removerLista({ ids : alertas}).then(() => {
                    this.alertaSucesso("Alertas excluídos com sucesso!");                    
                }).catch(err => {
                    if(err.response.status == 400){
                        this.alertaErro(err.response.data.errors);
                    }else{
                        this.alertaErro("Ocorreu um erro ao excluir os alertas");
                    }
                }).finally(() => {                     
                    this.buscarAlertas();
                    this.$store.dispatch("app/buscarAlertas");
                });
            });
        }
    },
    mounted(){
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Alertas"},
        ]);
        this.montarTipoAlertas();
        this.buscarAlertas();
    },
    computed : {
        usuario : function(){
            return this.$store.state.app.userInfo;
        },
        dadosFiltrados : function(){
            return this.dados.filter(el => {
                return this.tiposAlertas.find(tipo => el.tipo == tipo.value).selecionado
            });
        }
    }
}
</script>
<style>
    .corpo{
        white-space: nowrap;
        overflow: hidden !important;
        text-overflow: ellipsis;
        display: inline-block;
    }

    .pointer{
        cursor: pointer;
    }

    .borda-lateral{
        border-right: 1px solid rgba(0, 0, 0, 0.1);
    }

    .nao-visualizado{
        background-color: #f5f5f5;
        font-weight: 600;
    }

    .borda{
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
</style>